export function Card({ children, className = "", onClick = null }: {
  children: React.ReactNode;
  className?: string;
  onClick?: null | ((event?: any) => void);
}) {
  return (onClick === null) ? (
    <div className={`bg-white rounded-xl shadow-md ${className}`}>{children}</div>
  ) : (
    <div className={`bg-white rounded-xl shadow-md ${className}`} onClick={onClick}>{children}</div>
  )
}

export function CardContent({ className = "", children }: {className?: string, children: React.ReactNode}) {
  return <div className={`p-4 ${className}`}>{children}</div>;
}
